export default __webpack_public_path__ + "static/media/pvilla4-2.54f08d47.webp";